import api from '@/services/api2.service';

const DEFAULT_PRODUCT_SORT_PARAMS = Object.freeze({
    sort_by: 'order',
    sort_type: 'asc'
});

class ProductService {

    getProducts() {
        return api
            .get('/product', {
                params: {
                    ...DEFAULT_PRODUCT_SORT_PARAMS,
                    type: "individuals",
                    product_type: "subscription"
                }
            });
    }
    
    getProductsArray() {
        return api
            .get('/product', {
                params: {
                    ...DEFAULT_PRODUCT_SORT_PARAMS,
                    type: "individuals",
                    product_type: "subscription",
                    format: "array"
                }
            });
    }

    getPlanById(type) {
        return api
            .get('/product', {
                params: {
                    ...DEFAULT_PRODUCT_SORT_PARAMS,
                    type: "all",
                    product_type: "subscription",
                    tier: type
                }
            });

    }

    createOrder(price_id) {
        let params = {
            price_id: price_id,
            success_url: 'payment_success?session_id={CHECKOUT_SESSION_ID}',
            cancel_url: 'payment_cancel?session_id={CHECKOUT_SESSION_ID}'
        };
        return api.post('/payment/stripe/order-create', params);
    }

    cancel() {
       return api.delete('/payment/stripe/cancel-subscription');
    }
    verifyOrder(session_id) {
        return api.get(`/payment/stripe/order-verify/${session_id}`)
    }
    getSubscriptions() {
        return api
            .get('/subscription-get');
    }

    requestTrial( tier) {
        return api.post('/payment/manual/request-trial', {
            tier: tier
        });
    }

    onetimeBuy( price_id, quantity = false) {
        let params = {
            price_id: price_id,
            success_url: 'payment_success?session_id={CHECKOUT_SESSION_ID}',
            cancel_url: 'payment_cancel?session_id={CHECKOUT_SESSION_ID}'
        };

        if (quantity) {
            params.quantity = quantity;
        }
        return api.post('/payment/stripe/order-create', params);
    }
}
export default new ProductService();
